import React from 'react';
import NeatScheduleMark from '../../../../shared/components/brand/NeatScheduleMark';
import './AccountSetupLoadingOverlay.css';

const COPY = {
  paid: {
    subtitle:
      "We're setting up your account. This usually takes just a few seconds — please keep this tab open.",
    showSecure: true,
  },
  trial: {
    subtitle:
      "We're setting up your free trial. This usually takes just a few seconds — please keep this tab open.",
    showSecure: false,
  },
};

const AccountSetupLoadingOverlay = ({ isFreeTrial = false }) => {
  const copy = isFreeTrial ? COPY.trial : COPY.paid;

  return (
    <div className="accountSetupLoading" role="status" aria-live="polite" aria-busy="true">
      <div className="accountSetupLoading__panel">
        <div className="accountSetupLoading__logoWrap">
          <NeatScheduleMark className="accountSetupLoading__logo" />
        </div>

        <div className="accountSetupLoading__spinnerWrap">
          <span className="accountSetupLoading__spinnerGlow" aria-hidden="true" />
          <span className="accountSetupLoading__spinner" aria-hidden="true" />
        </div>

        <div className="accountSetupLoading__progress" aria-hidden="true">
          <span className="accountSetupLoading__progressBar" />
        </div>

        <h2 className="accountSetupLoading__title">Almost there!</h2>
        <p className="accountSetupLoading__subtitle">{copy.subtitle}</p>

        {copy.showSecure ? (
          <p className="accountSetupLoading__secure">
            <span className="accountSetupLoading__secureIcon" aria-hidden="true">
              🔒
            </span>
            Your payment info is encrypted and secure
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default AccountSetupLoadingOverlay;
